import { useCallback, useEffect, useState } from 'react';
import { billingAPI } from '../services/api';

const useEntitlements = ({ enabled = true } = {}) => {
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const refresh = useCallback(async () => {
    if (!enabled) {
      return;
    }

    try {
      setLoading(true);
      const response = await billingAPI.getStatus();
      setStatus(response.data);
      setError(null);
    } catch (err) {
      console.error('Failed to load entitlement status', err);
      setError(err);
    } finally {
      setLoading(false);
    }
  }, [enabled]);

  useEffect(() => {
    if (enabled) {
      refresh();
    } else {
      setLoading(false);
    }
  }, [enabled, refresh]);

  return {
    status,
    loading,
    error,
    refresh,
  };
};

export default useEntitlements;
